import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
`;

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
`;

export const ImgContainer = styled.div``;

export const FormContainter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border: 1px solid #eceff6;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f9faff 100%);
  padding: 18px;
  box-sizing: border-box;
  gap: 10px;
`;

export const InfoText = styled.span`
  display: block;
  padding: 0 4px 12px 4px;
  font-size: 14px;
  line-height: 1.4;
  color: #4b5563;
`;

export const FooterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const FooterLink = styled.span`
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  color: #4948ac;
`;
